import { axiosInstance } from "../../Utils/AxiosInstance";

const BASE = "/Procurement/PurchaseRequisition";

const call = async (fn) => {
  try {
    const response = await fn();
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

// status accepts a comma-separated list.
export const GetAllPurchaseRequisitionsApi = (projectId, status) => {
  const params = new URLSearchParams();
  if (projectId) {
    params.set("projectId", projectId);
  }
  if (status) {
    params.set("status", status);
  }
  const query = params.toString() ? `?${params.toString()}` : "";
  return call(() => axiosInstance.get(`${BASE}/GetAll${query}`));
};

export const GetPurchaseRequisitionByIdApi = (id) =>
  call(() => axiosInstance.get(`${BASE}/GetById/${id}`));

export const UpdatePurchaseRequisitionApprovalApi = (approvalId, status, comments) =>
  call(() =>
    axiosInstance.put(
      `${BASE}/UpdateApproval/${approvalId}?status=${encodeURIComponent(status)}&comments=${encodeURIComponent(comments || "")}`,
    ),
  );

// body: { approverUserIds: string[], lines: [{ lineId, estimatedRate }] }
export const EditPurchaseRequisitionApi = (id, body) =>
  call(() => axiosInstance.put(`${BASE}/Edit/${id}`, body));

// body: { reason, lines: [{ lineId, quantity }] } (empty lines = cancel everything open)
export const CancelPurchaseRequisitionLinesApi = (id, body) =>
  call(() => axiosInstance.post(`${BASE}/CancelLines/${id}`, body));
